export default __webpack_public_path__ + "static/media/image003.70ef77b7.png";